/**
 * 项目默认配置项
 */
const _ROLE_STATUS = {
  //组织
  ORGANIZATION: 1,
  //开发者
  DEV: 2
};
const _AUTH_STATUS = {
  //未认证
  AUTH_WAIT: 0,
  //已认证
  AUTH_CERTIFIED: 1,
  //认证中
  AUTH_PROGRESS: 2,
  //认证失败
  AUTH_FAILED: 3
};
//账号角色
const isManager = function () {
  return localStorage.USER_ROLE == _ROLE_STATUS.ORGANIZATION
    ? true
    : false;
}
//账号权限
const isCertified = function () {
  return localStorage.USER_AUTH == _AUTH_STATUS.AUTH_CERTIFIED
    ? true
    : false;
}
export default { isManager, isCertified, _AUTH_STATUS };